import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'
import { formatPhoneNumber } from 'helpers/phone-number'
import { getCurrentStorePhoneNumber } from 'selectors/getCurrentStore'
import TireControl from './TireControl'

const withMapPhoneNumber = withProps(({
  myStore,
  hasMapPrice,
  seePriceIncartMessage
}) => ({
  mapShowPhoneNumber: Boolean(myStore && hasMapPrice && seePriceIncartMessage.match(/call/i))
}))

const mapStateToProps = state => ({
  storePhoneNumber: getCurrentStorePhoneNumber(state),
  formattedStorePhoneNumber: formatPhoneNumber(getCurrentStorePhoneNumber(state)),
  myStore: state.myStore
})

export default compose(
  connect(mapStateToProps),
  withMapPhoneNumber
)(TireControl)
